import { Observable, switchMap } from 'rxjs';
import { IUploadService, UploadedState } from './upload-service.interface';
import { UserGameProfile } from '@fantaz/shared/data-access/models';

export abstract class UploadService implements IUploadService {
  upload(file: File): Observable<UploadedState> {
    return this.getPresignedUrl(file, {
      bucketType: 'identity-verification',
      key: file.name,
    }).pipe(
      switchMap((response) => {
        return this.uploadFileToS3(response.url, file);
      }),
    );
  }

  abstract imageValidation(value: UserGameProfile): Observable<UploadedState>;

  abstract getPresignedUrl(
    image: File,
    options: { bucketType: string; key: string },
  ): Observable<{ url: string }>;

  abstract uploadFileToS3(
    preSignedUrl: string,
    file: File,
  ): Observable<UploadedState>;
}
